export const negotiationMetricsResourceType = 'negotiation_metrics';
